<template>
  <header-middle />
  <!-- نمایش تخفیف های ویژه در صفحه اصلی و فروشگاه ها -->
  <bread-crumb :vector="[{fa : 'تخفیف های ویژه امروز',path : '/Category/a0'}]" v-if="$route.name == 'DampBtn' && $route.params.storeId == 'a0'"/>
  <bread-crumb :vector="[{fa : 'تخفیف های ویژه امروز در '+storeName,path : '/Category/'+$route.params.storeId}]" v-if="$route.name == 'DampBtn' && $route.params.storeId != 'a0' && storeName"/>
  <whole-damp  :shop_id="storeId" v-if="$route.name == 'DampBtn'" />
  <!-- نمایش دسته بندی ها -->
  <bread-crumb :vector="[{fa : 'فروشگاه '+ storeName,path : '/store/'+$route.params.storeId},{fa : 'دسته بندی '+ ordinateName,path : '/Category/ordinant/'+$route.params.item+'/'+$route.params.storeId}]" v-if="$route.name == 'CategoryPage' && ordinateName && storeName"/>
  <list-item v-if="wholeFlag == 'ordinant'" :group_id="id" :storeId="storeId" />
  <!-- نمایش همه در گروه های اصلی-->
  <bread-crumb :vector="[{fa : 'فروشگاه '+ storeName,path : '/store/'+$route.params.storeId},{fa : 'گروه '+ mainGroupName,path : '/Category/mainGroup/groups/'+$route.params.item+'/'+$route.params.storeId}]" v-if="$route.name == 'WoleBtn' && storeName && mainGroupName"/>
  <whole-item v-if="wholeFlag == 'groups'" :group_id="id" :storeId="storeId" />
  <!-- نمایش جدیدترین ها و پرفروش ترین ها -->
  <bread-crumb :vector="[{fa : 'پرفروش ترین ها',path : '/Category/best'}]" v-if="$route.name == 'bestWoleBtn'"/>
  <bread-crumb :vector="[{fa : 'جدید ترین ها',path : '/Category/newest'}]" v-if="$route.name == 'newestWoleBtn'"/>
  <main-whole v-if="$route.name == 'newestWoleBtn' || $route.name == 'bestWoleBtn'" />
  <grid-template />
  <footer-template />
</template>

<script setup>
import HeaderMiddle from '../section/header/header.vue';
import GridTemplate from "../section/footer/grids.vue";
import FooterTemplate from "../section/footer/footer.vue";
import BreadCrumb from "../section/item/BreadCrumb.vue";
import ListItem from "../section/pages/Group/listItem.vue";
import WholeItem from "../section/pages/Store/whole.vue";
import WholeDamp from "../section/pages/Store/DampWole.vue"
import MainWhole from '../section/pages/Home/Arrivals/WholeTemp.vue'
import { ref } from 'vue';
import { useRoute } from 'vue-router';
let route = useRoute();
// group id 
// console.log(route.name);
let id = route.params.item
let wholeFlag = route.params.whole;
let storeId = route.params.storeId
let storeName = ref('')
let ordinateName = ref('')
let mainGroupName = ref('')
if(route.name == 'DampBtn' && route.params.storeId != 'a0'){
  getStoreName()
}
if(route.name == 'CategoryPage'){
  getStoreName()
  getOrdinantName()
}
if(route.name == 'WoleBtn'){
  getStoreName()
  getMainGroupName()
}
async function getOrdinantName(){
 await fetch('https://radap.ir/Backend/api/section/pages/store/ordinate_name.php?id='+route.params.item)
  .then(res=>res.text())
  .then(data =>{
    ordinateName.value =  data
  })
}
async function getStoreName(){
 await fetch('https://radap.ir/Backend/api/section/pages/store/store_name.php?id='+route.params.storeId)
  .then(res=>res.text())
  .then(data =>{
    storeName.value =  data
  })
}
async function getMainGroupName(){
 await fetch('https://radap.ir/Backend/api/section/pages/store/main_group_name.php?id='+route.params.item)
  .then(res=>res.text())
  .then(data =>{
    mainGroupName.value =  data
  })
}

</script>
